import Image1 from "../images/saudia1.jpg";
import Image2 from "../images/saudia2.jpg";
import SectionHeading from "./ui/SectionHeading";
import GradientButton from "./ui/GradientButton";
import Reveal from "./ui/Reveal";

const packages = [
  {
    type: "Economy",
    features: ["Economy Hotels", "Shared Transport", "Visa", "Air Ticket"],
  },
  {
    type: "3 Star",
    features: ["Standard Hotels", "Private Transport", "Visa", "Air Ticket"],
  },
  {
    type: "5 Star",
    features: ["Luxury Hotels", "Private Transport", "Visa", "Air Ticket"],
    popular: true,
  },
];

const accents = ["border-brand-orange", "border-brand-orange", "border-brand-gold"];

const PackageSection = ({ title, image }) => {
  return (
    <div className="mb-16 last:mb-0">
      <Reveal className="mb-8 text-center">
        <h3 className="text-3xl font-extrabold text-brand-dark sm:text-4xl">
          {title} <span className="text-brand-green">Packages</span>
        </h3>
      </Reveal>

      {image && (
        <Reveal className="mx-auto mb-10 max-w-4xl overflow-hidden rounded-2xl shadow-soft">
          <img
            src={image}
            alt={title}
            className="h-56 w-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </Reveal>
      )}

      <div className="mx-auto grid max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {packages.map((pkg, i) => (
          <Reveal key={pkg.type} delay={i * 0.1}>
            <div
              className={`relative flex h-full flex-col items-center rounded-2xl border-t-[3px] bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-2 ${accents[i]} ${
                pkg.popular ? "ring-2 ring-brand-gold" : ""
              }`}
            >
              {pkg.popular && (
                <span className="absolute -top-3 rounded-full bg-gradient-to-r from-brand-orange to-brand-gold px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white shadow">
                  Most Popular
                </span>
              )}
              <h4 className="mb-4 mt-2 text-xl font-bold text-brand-dark">{pkg.type}</h4>
              <ul className="mb-6 space-y-2 text-center">
                {pkg.features.map((feature) => (
                  <li key={feature} className="text-sm text-gray-600">
                    <span className="mr-1 text-brand-gold">✓</span> {feature}
                  </li>
                ))}
              </ul>
              <GradientButton
                variant={pkg.popular ? "orange" : "green"}
                href="#contact"
                className="mt-auto"
              >
                Book Now
              </GradientButton>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

const HajjUmrah = () => {
  return (
    <section id="hajjumrah" className="section-pad bg-[#dfecd5]">
      <SectionHeading
        eyebrow="Hajj & Umrah"
        title="Sacred Journey Packages"
        subtitle="Carefully crafted Hajj and Umrah packages with visa, transport, flights and accommodation handled end-to-end."
      />
      <PackageSection title="Hajj" image={Image1} />
      <PackageSection title="Umrah" image={Image2} />
    </section>
  );
};

export default HajjUmrah;
